import React from 'react';
import Moment from 'moment';
import {
  DragSourceAndDropTarget,
  DragAndDropSpace,
} from '../../components/DnDWrapper';
import { isApiFlagOn } from '../../utilities/commonUtil';
import _ from 'lodash';

export const CraneContents = ({
  cranes,
  values,
  errors,
  isSettingId,
  callbacks,
  canDrag,
  infinityScrollLoad,
  selectedList,
  isSelectAll,
}) => {
  const DndSpace = element => {
    return <DragAndDropSpace>{element}</DragAndDropSpace>;
  };

  return DndSpace(
    <div className='setting-main__table scroll'>
      <table className='setting-table setting-min-width'>
        <thead className='setting-table__header'>
          <tr className='setting-table__label'>
            {!canDrag && (
              <td className='value-table gate-list-value-table__status sys-sort-toggle'>
                <input
                  type='checkbox'
                  checked={isSelectAll}
                  onChange={e => {
                    callbacks.table.selectAll(e.target.checked);
                  }}
                />
              </td>
            )}
            {canDrag && (
              <td className='value-table gate-list-value-table__drag'>
                <div className='value-table__label' />
              </td>
            )}
            <td className='value-table gate-list-value-table__status sys-sort-toggle'>
              <div className='value-table__label'>ステータス</div>
            </td>
            <td className='value-table gate-list-value-table__name sys-sort-toggle'>
              <div className='value-table__label'>揚重機名</div>
            </td>
            <td className='value-table gate-list-value-table__size sys-sort-toggle'>
              <div className='value-table__label'>性能</div>
            </td>
            <td className='value-table gate-list-value-table__size sys-sort-toggle'>
              <div className='value-table__label'>管理会社</div>
            </td>
            <td className='value-table gate-list-value-table__date sys-sort-toggle'>
              <div className='value-table__label'>登録日時</div>
            </td>
            <td className='value-table gate-list-value-table__date sys-sort-toggle'>
              <div className='value-table__label'>更新日時</div>
            </td>
          </tr>
        </thead>
        <tbody>
          {cranes.map((crane, index) => {
            return isSettingId === crane.id ? (
              <Crane
                key={crane.id}
                values={values}
                errors={errors}
                callbacks={callbacks}
              />
            ) : (
              <Crane
                key={crane.id}
                index={index}
                crane={crane}
                callbacks={callbacks}
                canDrag={canDrag}
                selectedList={selectedList}
              />
            );
          })}
          {}
        </tbody>
      </table>
      {infinityScrollLoad}
    </div>
  );
};

// eslint-disable-next-line no-unused-vars
const getStatus = (crane, onChangeStatus) => {
  if (crane.display_flag === 1) {
    return <span className='setting-status-using'>使用中</span>;
  }
  return <span className='setting-status'>未使用</span>;
};

export const Crane = ({ crane, callbacks, canDrag, index, selectedList }) => {
  const DndSrcTgt = element => {
    if (canDrag) {
      return (
        <DragSourceAndDropTarget
          id={`craneDnD`}
          index={index}
          data={crane}
          onHover={callbacks.dnd.onHover.bind(this)}
          onBeginDrag={callbacks.dnd.onBeginDrag.bind(this)}
          onDropped={callbacks.dnd.onDropped.bind(this)}
          canDrag={true}
          canDrop={true}
        >
          {element}
        </DragSourceAndDropTarget>
      );
    }

    return element;
  };

  const getSelected = () =>
    _.some(selectedList, selectedId => selectedId === crane.id);

  return DndSrcTgt(
    <tr
      id={`gate-${crane.id}`}
      className='setting-table__item'
      onClick={() => {
        !canDrag && callbacks.table.edit(crane);
      }}
    >
      {!canDrag && (
        <td
          className='gate-list-value-table__checkbox'
          onClick={e => e.stopPropagation()}
        >
          <input
            type='checkbox'
            checked={getSelected()}
            onChange={e =>
              callbacks.table.selectRow(e.target.checked, crane.id)
            }
          />
        </td>
      )}
      {canDrag && (
        <td className='gate-list-value-table__drag'>
          <button
            className='btn-icon--sm'
            style={{
              display: isApiFlagOn(crane.display_flag)
                ? 'inline-block'
                : 'none',
            }}
          >
            <i className='i-drag i-3x' />
          </button>
        </td>
      )}
      <td className='gate-list-value-table__status'>{getStatus(crane)}</td>
      <td className='gate-list-value-table__name'>
        <p>{crane.name}</p>
      </td>
      <td className='gate-list-value-table__name'>
        <span className='label'>性能</span>
        <p>{crane.spec_form}</p>
      </td>
      <td className='gate-list-value-table__name'>
        <span className='label'>管理会社</span>
        <p>{crane.partner_company_name}</p>
      </td>
      <td className='gate-list-value-table__date'>
        <span className='label'>登録日時</span>
        <div className='date-long'>
          <div className='date-long__date'>
            {Moment(crane.created_at).format('YYYY/MM/DD')}
          </div>
          <div className='date-long__time'>
            {Moment(crane.created_at).format('HH:mm')}
          </div>
        </div>
      </td>
      <td className='gate-list-value-table__date'>
        <span className='label'>更新日時</span>
        <div className='date-long'>
          <div className='date-long__date'>
            {Moment(crane.updated_at).format('YYYY/MM/DD')}
          </div>
          <div className='date-long__time'>
            {Moment(crane.updated_at).format('HH:mm')}
          </div>
        </div>
      </td>
    </tr>
  );
};



// WEBPACK FOOTER //
// ./src/components/tables/Crane.jsx